// Best-effort JWT payload decode; returns null on any parse failure.

const base64UrlToBase64 = (input: string): string => {
  let out = input.replace(/-/g, '+').replace(/_/g, '/');
  while (out.length % 4 !== 0) out += '=';
  return out;
};

// `atob` is available on React Native (Hermes) 0.71+ and every browser we
// ship to. The `Buffer` fallback covers older RN runtimes and Node-like
// hosts (e.g. jest without jsdom).
const decodeBase64 = (input: string): string => {
  if (typeof atob === 'function') return atob(input);
  return Buffer.from(input, 'base64').toString('utf8');
};

const readStringClaim = (token: string | null | undefined, name: string): string | null => {
  if (!token) return null;
  const parts = token.split('.');
  const payload = parts[1];
  if (!payload) return null;
  try {
    const claims = JSON.parse(decodeBase64(base64UrlToBase64(payload)));
    const value = claims?.[name];
    return typeof value === 'string' && value.length > 0 ? value : null;
  } catch {
    return null;
  }
};

export const getEmailFromAccessToken = (token: string | null | undefined): string | null =>
  readStringClaim(token, 'email');

export const getUserUuidFromAccessToken = (token: string | null | undefined): string | null =>
  readStringClaim(token, 'user_uuid');
